import { Row, ListGroup } from 'react-bootstrap';
import '../styles/components/info-modal-section.scss';
import AccordionCard from './AccordionCard';
import AccordionContainer from './AccordionContainer';
import FormatTable from './FormatTable';

const SerialNumberDescription = () => {
  return (
    <>
      <Row className="section">
        <h2>Overview</h2>
        <p>
          You must upload your files as a .txt file (.csv files to be supported in a future update)
          <br />
          Will be locked when taxes are computed - Approximately October 1
          <br /> <br />
          This allows you to submit the serial numbers you intend to pay. You may submit this file
          several times. You may see any errors by going to the “View/Correct Serial Number File
          Errors” link. The mortgage company you indicate will be shown on the owners tax notice.
          <br /> <br />
          The first record in the file should always be a Company Record, followed by all relevant
          Property Records.
        </p>
      </Row>
      <AccordionContainer id="reqSerialNumAccordion">
        <AccordionCard title="Edits" parent="reqSerialNumAccordion">
          <ListGroup variant="flush">
            <ListGroup.Item>- Valid serial number for year processing</ListGroup.Item>
            <ListGroup.Item>- Other tax service requested information</ListGroup.Item>
          </ListGroup>
        </AccordionCard>
        <FormatTable title="Requested Serial Number File" format="old" />
      </AccordionContainer>
    </>
  );
};

export default SerialNumberDescription;
